export default __webpack_public_path__ + "static/media/app.26c0ccb9.less";